import React, { useContext, useState,useEffect } from "react";

import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import FollowupTableComponent from "../../../components/tables/FollowupTableComponent";

import PageLayout from "../../../layouts/PageLayout";

import axios from "axios";
export default function AllFollowUps() {

    const AuthToken = localStorage.getItem("AuthUser");
    const [data,setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
          try {
            axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
            const response = await axios.get(
              process.env.REACT_APP_API_URL + "/all-family-followup"
            );
            setData(response.data.families);
            console.log("followup families",response.data.families);
           
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchData();
      }, []);
   
  
    // One row per family; its follow-ups are listed under the row
    const mappedData = data.map((family) => ({
        person_id: family.person_id,
        fsf_id: family.fsf_id || "",
        beneficiary_cnic: family?.cnic || "",
        beneficiary_name: family?.beneficiary_name || "",
        followup_count: family.followup_count || 0,
        last_visit: family?.last_visit || "",
        followups: family.followups || [],
        action: {
          edit: "edit",
          delete: "delete",
          view: "visibility",
        },
      }));
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{'All FollowUps'}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link"
                                style={{color:"#077834"}}>{"Home"}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link"
                                 style={{color:"#077834"}}>{"Families"}</Link></li>
                                <li className="mc-breadcrumb-item">{'FollowUps'}</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {/* {floats.map((float, index) => (
                    <Col key={ index } sm={6} lg={3}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))} */}
                <Col xl={12}>
                    <div className="mc-card">
                        <Row>
                           
                            <Col xl={12}>
                                <FollowupTableComponent 
                                    thead={ ["FSF ID", "Beneficiary CNIC", "Beneficiary Name", "Follow-ups", "Last Visit", "Action"] }
                                    tbody={ mappedData } 
                                />
                                {/* <PaginationComponent /> */}
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
